import { Config, SiteAddressDto } from '@ecdlink/core';
import { SiteAddressInput } from '@ecdlink/graphql';
import { api } from '../axios.helper';
import { inputObjectToCamelCase } from '@/utils/object-utils';
class SiteAddressService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async updateSiteAddress(
    id: string,
    input: SiteAddressInput
  ): Promise<boolean> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'UpdateSiteAddress',
      variables: {
        id: id,
        input: inputObjectToCamelCase(input),
      },
    });

    if (response.status !== 200) {
      throw new Error('Updating site address failed - Server connection error');
    }

    return true;
  }

  async getFranchisorSiteAddressById(
    franchisorId: string
  ): Promise<SiteAddressDto> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'GetFranchisorSiteAddressById',
      variables: {
        franchisorId: franchisorId,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get Coach Failed - Server connection error');
    }

    return response.data.data.franchisorSiteAddressById;
  }
}

export default SiteAddressService;
